export enum BlockableActivity {
  SHIPMENTS = "SHIPMENTS",
  INVOICING = "INVOICING",
}
